<template>
  <div class="col-lg-12" style="padding: 20px">
    <div class="main-card mb-3 card" style="margin-left: 10px">
      <div class="card-body">
        <h5 class="card-title">
          2024 Summer Camp 게임참여현황
          <div
            class="sub_title"
            style="
              margin-bottom: 20px;
              color: #333;
              font-size: 13px;
              border: 1px solid #ccc;
              background: #f8f8f8;
              height: 30px;
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
              padding: 2px 10px;
            "
          >
            2024 Summer Camp → 게임참여현황
          </div>
        </h5>
        <query-grid :config="config" ref="qg">
          <!-- <template #actions>
            <Create-Event ref="newSub" #default="m"> </Create-Event>
          </template> -->
          <template #resultactions=""
            ><!--추후 제공예정-->

            <div style="text-align: right">
              <!--button class="btn btn-danger"  @click="addHistory()" >2022 Summer Camp 테스트</button-->
              <!--button class="btn btn-danger" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg"
              @click="creatingMode()">2022 Summer Camp 신청하기</button-->
              <router-link to="/events/2024_Summer"
                ><button class="btn btn-secondary">
                  신청목록
                </button></router-link
              >
              <router-link to="/events/2024_Summer_view"
                ><button class="btn btn-secondary">
                  학습현황
                </button></router-link
              >
              <router-link to="/events/2024Summer"
                ><button class="btn btn-secondary">
                  학습 게시판
                </button></router-link
              >
            </div>
          </template>

          <template #items="props">
            <tr
              v-for="record in props.records"
              v-bind:key="record.id + record.timeStudy"
              :class="{ 'table-danger': record.is_deleted }"
            >
              <!-- <td style="text-align: center">
                <a href="#" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg"
                  @click="moreStudentInfo(record)">{{ record.username }}</a>
               </td> -->
               <td style="text-align: center">
                {{ record.username }}
               </td>
               <td style="text-align: center">
                <Student :student="record" />
              </td>
               <td style="text-align: center">
                {{ record.nationNm }}
               </td>
               <td style="text-align: center">
                {{ record.point }}
               </td>
               <td style="text-align: center">
                {{ record.missionPoint }}
               </td>
               <td style="text-align: center">
                {{ record.datPoint }}
               </td>
               <td style="text-align: center">
                {{ record.datWriteDate }}
               </td>
               <td style="text-align: center">
                {{ record.datRegDate }}
               </td>
               <td>
                <button
                  class="btn btn-danger btn-sm"
                  @click="deleteHistory(record)"
                >
                  삭제
                </button>
              </td>
              
              <td style="text-align: center">
                <span v-if="record.timeStudy">{{
                  record.timeStudy.substr(2, 8)
                }}</span>
              </td>
            </tr>
          </template> 
        </query-grid>
      </div>
    </div>
  </div>

  <Tree
    :key="$route.path"
    :tree-data="this.$root.businesses"
    :selectable="['CLASS']"
    render-button
    :callback="selectedBiz"
    :selectedNode="{ id: selData.activeBusiness }"
    ref="biz"
  />
</template>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import treeBtn from "../components/treeBtn";
import Business from "../components/Business";
import QueryGrid from "../components/QueryGrid";
import Student from "../components/detail_pages/Student";
import axios from "axios";
export default {
  name: "Home",
  components: {
    Tree,
    treeBtn,
    Business,
    Student,
    QueryGrid,
  },
  mounted() {
    if (this.$route.query.type) {
      /*this.typeFilter = {};
        this.typeFilter[this.$route.query.type] = true;*/
      this.$refs.qg.pushSetting(
        "status_filter_" + this.$route.query.type,
        true
      );
    }

    if (this.$root.guiPerm == "CLASS" || this.$root.guiPerm == "ENTERPRISE") {
      this.$refs.qg.pushSetting("status_filter_ACTIVE", true);
      this.config.columns.splice(0, 1);
    }

    this.$refs.qg.search();

    this.$watch(
      () => this.$route.query.type,
      function (toQuery, previousQuery) {
        // react to route changes...

        this.$refs.qg.pushSetting("status_filter_ACTIVE", false);
        this.$refs.qg.pushSetting("status_filter_INACTIVE", false);
        this.$refs.qg.pushSetting("status_filter_EVENT", false);
        if (toQuery)
          this.$refs.qg.pushSetting("status_filter_" + toQuery, true);

        this.$refs.qg.search();
      }
    );
  },
  methods: {
    selectedBiz(biz) {
      this.selBiz = biz;
      this.changedData.activeBusiness = biz.id;
    },
    
    deleteHistory(recode) {
      if (!confirm("정말로 삭제할까요")) return;
      axios.delete("/studies/eventGameHistory/" + recode.historyNo + "/"+ recode.totalPoint).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "삭제할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          $.notify(
            {
              // options
              message: "삭제되었습니다.",
            },
            {
              // settings
              type: "success",
              z_index: 9999,
            }
          );
          this.$refs.qg.search();
        }
      });
    },
    
    // creatingMode() {
    //   this.selData = {
    //     id: "",
    //     activeBusiness: "",
    //     username: "",
    //     password: "",
    //     hanName: "",
    //     engName: "",
    //     parentName: "",
    //     gender: "",
    //     bookclub_status: "",
    //     vocajoa_status: "",
    //     uracle_status: "",
    //     birth_of_day: "",
    //     phone: "",
    //     parentName: "",
    //     parentPhone: "",
    //     address: "",
    //     pass_allowed: false,
    //   };
    //   this.creating = true;
    //   this.changedData = {};
    // },
    // nvl(str) {
    //   if (typeof str == "undefined" || str == null) str = defaultStr;
    //   return str;
    // },
  },
  filters: {
    currency(value) {
      return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  data() {
    return {
      config: {
        name: "이벤트 게임참여 현황",
        req_endpoint: "/studies/eventGameHistory/summer2024",
        default_limit: 20,
        search_fields: [
          {
            id: "businesses",
            name: "소속선택",
            type: "business", // business, date, datetime,
          },
          {
            id: "search",
            name: "키워드검색",
            type: "text",
            placeholder: "아이디/이름/연락처",
          },
          {
            id: "date_filter",
            name: "날짜검색",
            type: "date",
            filter_type: {
              write_date: "제출일",
              regi_date: "참여일",
            },
          },
        ],
        columns: [
          // {
          //   id: "biz",
          //   sortable: true,
          //   name: "학원",
          //   excel_print: (v) => {
          //     return v.t2.name;
          //   },
          // },
          // {
          //   id: "class",
          //   sortable: true,
          //   name: "클래스/캠퍼스",
          //   excel_print: (v) => {
          //     return v.t1.name;
          //   },
          // },
          {
            id: "username",
            sortable: true,
            name: "아이디",
            excel_print: (v) => {
              return v.username;
            },
          },
          {
            id: "hanName",
            sortable: true,
            name: "이름",
            excel_print: (v) => {
              return v.name;
            },
          },
          {
            id: "nationNm",
            sortable: true,
            name: "방문국가",
            excel_print: (v) => {
              return v.nationNm;
            },
          },
          {
            id: "point",
            sortable: true,
            name: "획득점수",
            excel_print: (v) => {
              return v.point;
            },
          },

          {
            id: "missionPoint",
            sortable: true,
            name: "미션점수",
            excel_print: (v) => {
              return v.missionPoint;
            },
          },
          {
            id: "datPoint",
            sortable: true,
            name: "누적점수",
            excel_print: (v) => {
              return v.datPoint;
            },
          },
          {
            id: "datWriteDate",
            sortable: true,
            name: "제출일",
            excel_print: (v) => {
              return v.datWriteDate;
            },
          },
          {
            id: "datRegDate",
            sortable: true,
            name: "참여일",
            excel_print: (v) => {
              return v.datRegDate;
            },
          },
          {
            id: "action",
            name: "관리",
          },
        ],
        disable_init_search: true,
      },
      selBiz: {
        name: "",
      },
      subscriptions: [],
      selData: {
        id: "",
        activeBusiness: "",
        username: "",
        password: "",
        hanName: "",
        engName: "",
        parentName: "",
        gender: "",
        birth_of_day: "",
        phone: "",
        address: "",
        pass_allowed: false,
      },
      changedData: {},
      selProduct: {},
      selectedSubscription: {
        id: 0,
      },
      products: [],
      creating: true,
    };
  },

};
</script>
